/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router'
import { Button, Table, message, Modal } from 'antd';
import { DmsTab, DataList, RemarkModal, UploadFile } from 'Components';
import { detail } from '../../service/store';
import { config } from 'Utils';
import { getSellerList, openAccount } from '../../service/store/staff';
import { accountResetPwd, accountInvalid } from '../../service/account';
import { getList as getRemarkList, deleteRemarks } from '../../service/remark/remark'
import { getList as getFileList, deleteFiles, addFileDownCount } from '../../service/remark/file'
const confirm = Modal.confirm;

class StoreDetail extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      storeId: parseInt(this.props.params.storeId, 10),
      detail: {},
      staffs: [],
      remarks: [],
      files: [],
      fileTotal: 0,
      staffTotal: 0,
      remarkTotal: 0,
    }
    this.getFiles = this.getFiles.bind(this);
    this.getStaffs = this.getStaffs.bind(this);
    this.getDetail = this.getDetail.bind(this);
    this.getRemarks = this.getRemarks.bind(this);
  }

  componentDidMount () {
    this.getFiles();
    this.getDetail();
    this.getStaffs();
    this.getRemarks();
  }

  goView (url) {
    hashHistory.push(url);
  }

  goBack () {
    hashHistory.goBack();
  }

  openModal () {
    this.remarkModal.showModal();
  }

  getDetail () {
    const self = this;
    detail(self.state.storeId).then(res => {

      self.setState({
        ...this.state,
        detail: res.data.dmsStore
      })
    })
  }

  getStaffs () {
    const self = this;
    getSellerList({id: this.state.storeId, p: 1, s: 5}).then(res => {

      self.setState({
        ...this.state,
        staffs: res.data,
        staffTotal: res.total
      })
    })
  }

  getRemarks () {
    const self = this;
    getRemarkList({ relatedTableType: 3, relatedTableId: self.state.storeId, p: 1, s: 5 }).then(res => {

      self.setState({
        ...this.state,
        remarks: res.data,
        remarkTotal: res.total
      })
    })
  }

  deleteRemark (id) {
    const self = this;
    confirm({
      title: '确定要删除这条记录?',
      //content: 'Some descriptions',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteRemarks({ id }).then(res => {
          message[res.status ? 'success' : 'error'](res.message);
          res.status && self.getRemarks();
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  getFiles () {
    const self = this;
    getFileList({ dealType: 3, id: self.state.storeId, p: 1, s: 5 }).then(res => {

      self.setState({
        ...this.state,
        files: res.data,
        fileTotal: res.total
      })
    })
  }

  deleteFile (id) {
    const self = this;
    confirm({
      title: '确定要删除附件?',
      //content: 'Some descriptions',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteFiles({ ids: [id] }).then(res => {
          message[res.status ? 'success' : 'error'](res.message);
          res.status && self.getFiles();
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  downCount (id) {
    const self = this;
    addFileDownCount({ id }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getFiles();
    })
  }

  createAccount(staffId){
    const self = this;
    openAccount({sellerId: staffId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getStaffs();
    })
  }
  invalidAccount(accountId){

    const self = this;
    accountInvalid({id: accountId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getStaffs();
    })
  }
  resetPwd(accountId){

    const self = this;
    accountResetPwd({id: accountId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getStaffs();
    })
  }

  render () {
    const self = this;

    const { detail, storeId, staffs, files, remarks, fileTotal, staffTotal, remarkTotal } = this.state;
    const cells = {
      code: {
        title: '门店编码',
      },
      operateWayText: {
        title: '运营方式',
      },
      employeeName: {
        title: '业务员',
      },
      storeAddress: {
        title: '地址',
        render: () => `${detail.provinceText || ''}${detail.cityText === '市辖区' || detail.cityText === '县' ? '' : detail.cityText}${detail.countyText||''}${detail.storeAddress||''}`
      },
      dealerName: {
        title: '经销商',
      },
      storeTypeText: {
        title: '门店类型',
      },
      sellVolume: {
        title: '年销售额',
        render: () => detail.sellVolume ? `${detail.sellVolume}万元` : ''
      },
      storeEmployeeNum: {
        title: '员工总数',
      },
      storeArea: {
        title: '店面面积',
        render: text => text ? text + 'm²' : ''
      },
      storePhone: {
        title: '店面电话',
      },
      openDate: {
        title: '开业时间',
        render: text => text ? new Date(text).format('yyyy-MM-dd') : '----'
      },
      closeDate: {
        title: '关停时间',
        render: text => text ? new Date(text).format('yyyy-MM-dd') : '----'
      },
      createdDate: {
        title: '创建时间',
        render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : '----'
      },
      lastUpdatedDate: {
        title: '最后更新',
        render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm:ss') : '----'
      }
    };
    const staffProps = {
      rowKey: 'id',
      columns: [
        {
          title: '姓名',
          dataIndex: 'name',
          render: (text, record, index) => <a href={`#/staff/${storeId}/${record.id}`}>{text}</a>
        },
        {
          title: '性别',
          dataIndex: 'sexText',
        },
        {
          title: '手机',
          dataIndex: 'mobileText',
        },
        {
          title: '座机',
          dataIndex: 'phoneText',
        },
        {
          title: '邮箱',
          dataIndex: 'emailText',
        },
        {
          title: '岗位',
          dataIndex: 'postText',
        },
        {
          title: '状态',
          dataIndex: 'active',
          render: (text, record, index) => {
            if(text == 0) return '离职';
            if(text == 1) return '在职';
            return '';
          }
        },
        {
          title: '账号',
          dataIndex: 'dmsUser',
          render: (dmsUser, record, index) => dmsUser && dmsUser.account ? dmsUser.account : ''
        },
        {
          title: '操作',
          dataIndex: '',
          render: (text, record, index) => record.dmsUser !== null?<span>
            <a onClick={self.invalidAccount.bind(self, record.dmsUser.id)}>禁用账号</a>&nbsp;&nbsp;&nbsp;
            <a onClick={self.resetPwd.bind(self, record.dmsUser.id)}>重置密码</a>
          </span> : <span>
            <a onClick={self.createAccount.bind(self, record.id)}>开通账号</a>
          </span>
        },
      ],
      dataSource: staffs
    };
    const fileProps = {
      rowKey: 'id',
      columns: [
        {
          title: '标题',
          dataIndex: 'fileName',
        },
        {
          title: '创建时间',
          dataIndex: 'createdDate',
          render: (text) => new Date(text).format('yyyy-MM-dd hh:mm')
        },
        {
          title: '下载次数',
          dataIndex: 'downloadCount',
        },
        {
          title: '类型',
          dataIndex: 'extension',
        },
        {
          title: '大小',
          dataIndex: 'size',
          render: (text, record, index) => text.bytesToSize()
        },
        {
          title: '操作',
          dataIndex: 'fileId',
          render: (text, record, index) => <span>
            <a href={`${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${text}`}
               onClick={this.downCount.bind(self, text)}>下载</a>&nbsp;&nbsp;&nbsp;
            <a onClick={this.deleteFile.bind(self, text)}>删除</a>
          </span>
        },
      ],
      dataSource: files
    };
    const remarkProps = {
      rowKey: 'id',
      columns: [
        {
          title: '主题',
          dataIndex: 'content',
        },
        {
          title: '创建时间',
          dataIndex: 'createdDate',
        },
        {
          title: '操作',
          dataIndex: '',
          render: (text, record, index) => <span><a onClick={self.deleteRemark.bind(self, record.id)}>删除</a></span>
        },
      ],
      dataSource: remarks
    };
    return <div className="dms-main-box">
      <div>
        <DmsTab options={['门店详情']} defaultKey={0}>
          <Button onClick={this.goView.bind(this, `/store/add/${storeId}`)}>编辑</Button>
          <Button onClick={this.goBack}>返回</Button>
        </DmsTab>
        <div className="dms-table-box">
          <div className="dms-detail-brief-box">
            <img className="store-logo" alt="门店logo" src={detail.picUrl ? config.server+detail.picUrl : require('../../assets/images/store-default-log.png')}/>
            <p style={{fontSize: '24px', marginLeft: '15px', height: '84px', lineHeight: '84px', float: 'left'}}>{detail.name}</p>
          </div>
          <DataList cells={cells} data={detail}></DataList>
        </div>
      </div>
      <div>
        <DmsTab className="white-bg no-border" options={['店员']} defaultKey={0}>
          <Button type="primary"
                  onClick={this.goView.bind(this, `/staff/${storeId}/add/0`)}>新增店员</Button>
        </DmsTab>
        <div className="dms-table-box">
          <Table {...staffProps} bordered pagination={false}/>
          <br />
          {!!staffTotal && <p><a onClick={this.goView.bind(this, `/staff/${storeId}`)}>查看全部（{staffTotal}）</a></p>}
        </div>
      </div>
      <div className="dms-split-bar"></div>
      <div>
        <DmsTab className="white-bg no-border" options={['附件']} defaultKey={0}>
          <UploadFile color="red" entityType="store" entityId={storeId} onSuccess={this.getFiles}/>
        </DmsTab>
        <div className="dms-table-box">
          <Table {...fileProps} bordered pagination={false}/>
          <br />
          {!!fileTotal &&
          <p><a onClick={this.goView.bind(this, `/file?entityId=${storeId}&entityType=store`)}>查看全部（{fileTotal}）</a>
          </p>}
        </div>
      </div>
      <div className="dms-split-bar"></div>
      <div>
        <DmsTab className="white-bg no-border" options={['备注']} defaultKey={0}>
          <Button type="primary" onClick={this.openModal.bind(this)}>新建备注</Button>
        </DmsTab>
        <div className="dms-table-box">
          <Table {...remarkProps} bordered pagination={false}/>
          <br />
          {!!remarkTotal &&
          <p><a onClick={this.goView.bind(this, `/remark?entityId=${storeId}&entityType=store`)}>查看全部（{remarkTotal}）</a>
          </p>}
        </div>
      </div>
      <RemarkModal ref={(node) => { this.remarkModal = node; }}
                   entityType="store"
                   entityId={storeId}
                   onSuccess={this.getRemarks}/>
    </div>
  }
}
;
export default StoreDetail;


// WEBPACK FOOTER //
// ./src/routes/store/detail.js